export function replaceTextareaSelection(
    value: string,
    start: number,
    end: number,
    inserted: string,
): { value: string; caret: number } {
    return {
        value: value.slice(0, start) + inserted + value.slice(end),
        caret: start + inserted.length,
    };
}

export function createTiptapDictationTarget(editor: Editor) {
    const { from, to } = editor.state.selection;
    const lockedDocument = editor.state.doc;
    const isCurrentTarget = () =>
        !editor.isDestroyed && editor.state.doc.eq(lockedDocument);
    return {
        isValid() {
            return isCurrentTarget();
        },
        insert(text: string) {
            if (!isCurrentTarget()) {
                throw new Error("STALE_DICTATION_TARGET");
            }
            editor.chain().focus().insertContentAt({ from, to }, text).run();
            const insertedDocument = editor.state.doc;
            return () => {
                if (editor.isDestroyed || !editor.state.doc.eq(insertedDocument)) return;
                editor.chain().focus().undo().run();
            };
        },
        restoreFocus() {
            if (!editor.isDestroyed) editor.commands.focus();
        },
    };
}
import type { Editor } from "@tiptap/core";
